const TecPpmLookupConfig = {
  collection: "tec_ppm_lookup",
  fields: [
    "date_created",
    "date_updated",
    "speed",
    "jobs_per_day",
    "images_per_job",
    "images_per_job_rounded",
    "images_per_day"
  ],

  adapter: class TecPpm {
    constructor(item) {
      Object.assign(this, {
        date_updated: item.date_updated || item.date_created,
        speed: Number.parseFloat(item.speed || 0),
        jobs_per_day: Number.parseFloat(item.jobs_per_day || 0),
        images_per_job: Number.parseFloat(item.images_per_job || 0),
        images_per_job_rounded: Number.parseFloat(
          item.images_per_job_rounded || 0
        ),
        images_per_day: Number.parseFloat(item.images_per_day || 0)
      });
    }
  }
};

export default TecPpmLookupConfig;
